<template>
  <div class="storeSetup">
    <div class="storename">
      <div class="name">{{ storename }}</div>
      <div class="rightgo">
        <div class="directSend">{{ storetype }}</div>
      </div>
    </div>

    <div class="state">
      <div class="currenttype">状态：{{ currenttype }}</div>
    </div>
  </div>
</template>
<script>
import { onoffShop } from '@/models/goodsModel'
export default {
  data () {
    let storetype
    if (localStorage.getItem('shop_type') === '0') {
      storetype = '平台'
    }
    if (localStorage.getItem('shop_type') === '1') {
      storetype = '直发'
    }
    if (localStorage.getItem('shop_type') === '2') {
      storetype = '工厂'
    }
    return {
      storeswitch: localStorage.getItem('is_enable') === '1',
      storename: localStorage.getItem('username'),
      storetype: storetype,
      currenttype: localStorage.getItem('is_enable') === '1' ? '开店' : '关店'
    }
  },
  mounted () {
    this.getstore()
  },
  watch: {
    storeswitch (val) {
      this.currenttype = val ? '开店' : '关店'
    }
  },
  methods: {
    // 获取店铺状态
    getstore () {},
    witch_dian (val) {
      this.$confirm('是否确认此操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          let params = {
            type: this.storeswitch === true ? 1 : 0
          }
          let that = this
          let data = await onoffShop(params, that)
          if (data.code === 200) {
            localStorage.setItem(
              'is_enable',
              this.storeswitch === true ? 1 : 0
            )
          } else {
            this.storeswitch = !this.storeswitch
          }
        })
        .catch(() => {
          this.storeswitch = !this.storeswitch
          this.$message({
            type: 'info',
            message: '已取消修改'
          })
        })
    }
  }
}
</script>
<style lang="scss">
.storeSetup {
  padding: 10px;
  .storename {
    border-bottom: 1px solid #ccc;
    height: 50px;
    line-height: 50px;
    .name {
      display: inline-block;
      font-size: 24px;
      padding-right: 20px;
    }
    .rightgo {
      display: inline-block;
      width: 50px;
      height: 15px;
      border-radius: 15px;
      overflow: hidden;
      bottom: -5px;
      left: 50%;
      font-size: 12px;
      line-height: 16px;
      color: #fff;
      text-align: center;
      .directSend {
        background-color: blue;
      }
    }
  }
  .state {
    height: 50px;
    line-height: 50px;
    .currenttype {
      float: left;
      font-size: 14px;
      color: #333;
      padding-right: 30px;
    }
    .el-switch.is-checked .el-switch__core {
      border-color: #ff6224;
      background: #ff6224;
    }
    .el-switch__label.is-active {
      color: #ff6224;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/basic/storeSetup.vue